import dynamic from "next/dynamic";
import { IconsProps, BoxIconProps } from "./types";
import styles from "./index.module.scss";

const ArrowIcon = dynamic(() => import("@/src/components/icons/ArrowIcon"));
const ArrowIcon2 = dynamic(() => import("@/src/components/icons/ArrowIcon2"));
const CalendarIcon = dynamic(
  () => import("@/src/components/icons/CalendarIcon")
);
const PieChartIcon = dynamic(
  () => import("@/src/components/icons/PieChartIcon")
);
const EyeCloseIcon = dynamic(
  () => import("@/src/components/icons/EyeCloseIcon")
);
const EyeOpenIcon = dynamic(() => import("@/src/components/icons/EyeOpenIcon"));
const ClearIcon = dynamic(() => import("@/src/components/icons/ClearIcon"));
const SearchIcon = dynamic(() => import("@/src/components/icons/SearchIcon"));
const ArrowBackIcon = dynamic(
  () => import("@/src/components/icons/ArrowBackIcon")
);

const Icon = (props: IconsProps) => {
  const elementProperty = {
    size: props.size,
    color: props.color,
    rotate: props.rotate,
  };

  if (props.select === "arrow") {
    return <ArrowIcon {...elementProperty} />;
  } else if (props?.select === "arrow2") {
    return <ArrowIcon2 {...elementProperty} />;
  } else if (props?.select === "calendar") {
    return <CalendarIcon {...elementProperty} />;
  } else if (props?.select === "pie_chart") {
    return <PieChartIcon {...elementProperty} />;
  } else if (props?.select === "eye_open") {
    return <EyeOpenIcon {...elementProperty} />;
  } else if (props?.select === "clear") {
    return <ClearIcon {...elementProperty} />;
  } else if (props?.select === "search") {
    return <SearchIcon {...elementProperty} />;
  } else if (props?.select === "arrow_back") {
    return <ArrowBackIcon {...elementProperty} />;
  }
  return <EyeCloseIcon {...elementProperty} />;
};

Icon.defaultProps = {
  size: "12",
  color: "#F36F21",
  rotate: "0",
  select: "eye_close",
};

const Icons = (props: BoxIconProps) => {
  const iconProperty = {
    select: props.select,
    size: props.size,
    color: props.color,
    rotate: props.rotate,
  };
  return (
    <div
      className={`${styles.icons} ${styles["icons-size--" + props?.size]} ${
        styles["icons-variant--" + props?.mode]
      } ${
        props?.backgroundColor !== "none"
          ? styles["icons-background--" + props?.backgroundColor]
          : ""
      }`}
    >
      <Icon {...iconProperty} />
    </div>
  );
};

Icons.defaultProps = {
  mode: "none",
  backgroundColor: "none",
  size: "12",
  color: "#F36F21",
  rotate: "0",
  select: "eye_close",
};

export default Icons;
